'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var useDefaultInternalState = require('../../hooks/useDefaultInternalState.js');
var ListBlock = require('./ListBlock.js');
var reorderableList_module = require('./reorderableList.module.scss.js');

var ReorderableList = function (_a) {
    var list = _a.list, setList = _a.setList, cardSize = _a.cardSize;
    var _b = useDefaultInternalState.default(list, setList), listData = _b[0], setListData = _b[1];
    var fullWidthCard = cardSize === 'lg' ? 'w-100' : '';
    var position = react.useRef([
        react.createRef(),
        react.createRef(),
        react.createRef(),
        react.createRef()
    ]);
    react.useEffect(function () {
        var lastItem = listData.length - 1;
        var update = listData.map(function (item) {
            if (item.id === listData[0].id) {
                return tslib.__assign(tslib.__assign({}, item), { disabledUp: true, disabledDown: false });
            }
            else if (item.id !== listData[0].id &&
                item.id !== listData[lastItem].id) {
                return tslib.__assign(tslib.__assign({}, item), { disabledUp: false, disabledDown: false });
            }
            else if (item.transition) {
                return tslib.__assign(tslib.__assign({}, item), { transition: false });
            }
            else {
                return tslib.__assign(tslib.__assign({}, item), { disabledUp: false, disabledDown: true });
            }
        });
        setListData(tslib.__spreadArray([], update, true));
    }, [
        listData[0].id,
        listData[0 + 1].id,
        listData[listData.length - 2].id,
        listData[listData.length - 1].id
    ]);
    var setIsActiveTransition = function (id, idTwo) {
        setListData(function (prevState) {
            var newState = prevState.map(function (obj) {
                if (obj.id === id || obj.id === idTwo.id) {
                    return tslib.__assign(tslib.__assign({}, obj), { transition: true });
                }
                return obj;
            });
            return newState;
        });
    };
    var onClickUpDown = function (e, id, direction, i) {
        e.stopPropagation();
        if (listData && listData.length > 0) {
            var updateArray_1 = tslib.__spreadArray([], listData, true);
            var foundIdx_1 = updateArray_1.findIndex(function (el) { return el.id === id; });
            var element_1 = updateArray_1[foundIdx_1];
            var movement_1 = direction === 'down' ? foundIdx_1 + 1 : foundIdx_1 - 1;
            var idTwo = direction === 'down'
                ? updateArray_1[foundIdx_1 + 1]
                : updateArray_1[foundIdx_1 - 1];
            setIsActiveTransition(id, idTwo);
            var childA_1 = position.current[i].current;
            var childB_1 = position.current[movement_1].current;
            var finalChildAStyle = {
                x: 0,
                y: 0
            };
            var finalChildBStyle = {
                x: 0,
                y: 0
            };
            childA_1 === null || childA_1 === void 0 ? void 0 : childA_1.classList.add(reorderableList_module.default['container-card-transition']);
            childB_1 === null || childB_1 === void 0 ? void 0 : childB_1.classList.add(reorderableList_module.default['container-card-transition']);
            if (childA_1 !== null && childB_1 !== null) {
                finalChildAStyle.x =
                    childA_1.getBoundingClientRect().left -
                        childB_1.getBoundingClientRect().left;
                finalChildAStyle.y =
                    childB_1.getBoundingClientRect().top -
                        childA_1.getBoundingClientRect().top;
                finalChildBStyle.x =
                    childB_1.getBoundingClientRect().left -
                        childA_1.getBoundingClientRect().left;
                finalChildBStyle.y =
                    childA_1.getBoundingClientRect().top -
                        childB_1.getBoundingClientRect().top;
                childA_1.style.transform = "translate(".concat(finalChildAStyle.x, "px, ").concat(finalChildAStyle.y, "px)");
                childB_1.style.transform = "translate(".concat(finalChildBStyle.x, "px, ").concat(finalChildBStyle.y, "px)");
                setTimeout(function () {
                    updateArray_1.splice(foundIdx_1, 1);
                    updateArray_1.splice(movement_1, 0, element_1);
                    setListData(tslib.__spreadArray([], updateArray_1, true));
                    childA_1 === null || childA_1 === void 0 ? void 0 : childA_1.classList.remove(reorderableList_module.default['container-card-transition']);
                    childB_1 === null || childB_1 === void 0 ? void 0 : childB_1.classList.remove(reorderableList_module.default['container-card-transition']);
                    childB_1 === null || childB_1 === void 0 ? void 0 : childB_1.removeAttribute('style');
                    childA_1 === null || childA_1 === void 0 ? void 0 : childA_1.removeAttribute('style');
                }, 260);
            }
        }
    };
    return (jsxRuntime.jsx("div", tslib.__assign({ className: "".concat(reorderableList_module.default['cardblock'], " ").concat(cardSize === 'lg' ? 'p-0' : '') }, { children: listData && listData.length > 0
            ? listData.map(function (item, i) { return (jsxRuntime.jsx("div", tslib.__assign({ ref: position.current[i], className: "".concat(fullWidthCard) }, { children: jsxRuntime.jsx(ListBlock.default, tslib.__assign({ onClickDown: function (e) {
                        return onClickUpDown(e, item.id, 'down', i);
                    }, onClickUp: function (e) {
                        return onClickUpDown(e, item.id, 'up', i);
                    }, id: item.id, disabledUp: item.disabledUp, disabledDown: item.disabledDown, title: item.title, description: item.description, transition: item.transition, cardSize: cardSize }, { children: item.children }), item.id) }), item.id)); })
            : null })));
};
var ReorderableList$1 = ReorderableList;

exports.default = ReorderableList$1;
//# sourceMappingURL=ReorderableList.js.map
